export const receiveType: number = 1